/**
 * A country's name from its key, out of the countries list the Automation
 * pages already load (cached for an hour); the key itself until it loads.
 * For Media Devoted | Created By Ciro Autiero
 */
import { useCountries } from '@/hooks/smswiser/core/useSMSWiser';

export function useCountryName(countryKey: string): string {
  const countries = useCountries();
  return countries.data?.find((c) => c.key === countryKey)?.name ?? countryKey;
}

/** v2 (26/10/2026) — every country's name by its key, for a paste into several countries. */
export function useCountryNameOf(): (countryKey: string) => string {
  const countries = useCountries();
  return (countryKey) => countries.data?.find((c) => c.key === countryKey)?.name ?? countryKey;
}
